import { render, staticRenderFns } from "./sync-save.vue?vue&type=template&id=1e48d3d0&scoped=true&"
import script from "./sync-save.vue?vue&type=script&lang=js&"
export * from "./sync-save.vue?vue&type=script&lang=js&"
import style0 from "./sync-save.vue?vue&type=style&index=0&id=1e48d3d0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e48d3d0",
  null
  
)

export default component.exports